// PHA-1243: billing reports on the Billing page. A billing report made here lives here (it is not
// listed on the Reports page) and still runs from Ask Phanova by #handle. Shown when reports are on
// for the org and there is something to list or the user can design one.
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card, Flex, Heading, Text } from '@radix-ui/themes';
import { PlusIcon } from '@radix-ui/react-icons';
import ReportList from './ReportList';
import { useSavedReports } from './useSavedReports';
import { useCustomViewsAccess } from '../customViews/useCustomViews';

const BillingReportsPanel: React.FC<{ orgId: string }> = ({ orgId }) => {
  const navigate = useNavigate();
  const access = useCustomViewsAccess(orgId, 'report');
  const saved = useSavedReports(orgId, { enabled: access.enabled, maxAgeMs: 0 });
  const reports = useMemo(() => saved.reports.filter((r) => r.home === 'billing'), [saved.reports]);

  if (!orgId || !access.enabled || (!access.canDesign && reports.length === 0)) return null;
  return (
    <Card mb="4" data-testid="billing-reports">
      <Flex direction="column" gap="3">
        <Flex justify="between" align="center" wrap="wrap" gap="2">
          <Flex direction="column">
            <Heading size="3">Billing reports</Heading>
            <Text size="1" color="gray">Saved billing reports. Type # in Ask Phanova to run one.</Text>
          </Flex>
          {access.canDesign && (
            <Button onClick={() => navigate('/billing/reports/new')}><PlusIcon /> New billing report</Button>
          )}
        </Flex>
        <ReportList
          reports={reports}
          canDesign={access.canDesign}
          emptyText='No billing reports yet. Use "New billing report" to describe one in plain English.'
          onChanged={saved.refresh}
        />
      </Flex>
    </Card>
  );
};

export default BillingReportsPanel;
